import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import StarRatings from 'react-star-ratings'; 
import Button from '@mui/material/Button';
import Tooltip  from "@material-ui/core/Tooltip";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useNavigate } from 'react-router-dom';
import {FE_URL} from '../../Constants'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {API_URL} from '../../Constants';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import NewsLetterImage from "../../images/NewsLetterImage.png";
import SendIcon from '@mui/icons-material/Send';
import { withStyles } from "@material-ui/core/styles";
import '../FormContainer1.css';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 5,
};
var Router = require('react-router');
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));
const CustomTextTypography = withStyles({
  root: {
    color: "red"
  }
})(Typography);
export default function StyledPropCard2(props) {
  var Link = Router.Link;
  const [expanded, setExpanded] = React.useState(false);
  const [DetailsNewURL, setDetailsNewURL] = useState("/detailsnew?zpid=" + props.zpid );
  const navigate = useNavigate();
  const handleClick = () => navigate('/PropDetails',{ state: { props: props } });
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(false);
  const handleClose = () => setOpen(false); 

  const [subject, setSubject] = useState("Support Issue");
  const [recipientEmail, setRecipientEmail] = useState();
  const [message, setMessage] = useState( );
  const [emailValid, setEmailValid] = useState(true);
  const [lastName, setLastName] = useState();
  const [newsletter, setNewsletter] = useState(true);
  const [active, setActive] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [emailNotValid, setEmailNotValid] = useState(false);
  const [cityNotValid, setCityNotValid] = useState(false);
  const [senderEmail, setSenderEmail] = useState();
  const [emailaddress, setEmailAddress] = useState();
  const [maxWidth, setMaxWidth] = React.useState('md');
  const [city, setCity] = useState('Preferred NewsLetter City');
  const handleChangeCityData = (event) => 
  {
    console.log("Dropdown value for city:" + event.target.value);
    setCity(event.target.value);
  } 
  async function emailSupport(shareinfo) {
    setActive(true);
    //const postData = { email: email ,password:password ,firstname:firstName, lastname:lastName,newletter:newsletter};
     const email = '/api/email/tempsubscribe?emailaddress=' + emailaddress + "&city=" + city
     //const emailstring = '/api/email/NewsletterUserSubscribe';
     return fetch(API_URL +  email, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
       
      })
      .then(data => data.json()) // Return the parsed JSON here
  .then(emailstring => {
    setShowResults(true);
    setActive(false);
    // Handle parsedData if needed
  })
  .catch(error => {
    // Handle any errors that occurred during the fetch request
    console.error('Error:', error);
  });
        // .then(data =>{ data.json(); setShowResults(true); setActive(false)})
     }
  
     
  function emailValidation(){
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!emailaddress || regex.test(emailaddress) === false){
        //setEmailValid(false);
        setEmailNotValid(true)
        return false;
    }
   // setEmailValid(true);
    setEmailNotValid(false);
    return true;
  }


  function buildSimilarPercentageString(num) {
        
    if (num<0){
      return num + '% below similar property average. '
    }else if (num>0) 
    {
      return num + '% above similar property average. '
    } 
  }
  function buildPercentageString(num) {
  
    if (num<0){
      return num + '% below nearby home average. '
    }else if (num>0) 
    {
      return num + '% above nearby home average. '
    } 
  }
  function getPriceAction(priceaction){
    //<p  style={{color:"red", align:"center",fontSize: "15px", display: 'inline' }}>JUST LISTED</p> <p style={{color:"red", align:"center",fontSize: "15px", display: (props.priceAction===null||props.priceAction===undefined|| props.priceAction==='')? 'none'  : 'inline'}}></p><p     style={{color:"red", align:"center",fontSize: "15px", display: props.priceAction==="REDUCED" ? 'none' : 'inline'}}>REDUCED</p>
    var returnPriceAction="     ";
    if(props.isNew){
        returnPriceAction = "JUST LISTED";
    }else if(props.priceAction!=null) {
        returnPriceAction=props.priceAction;
    }else {
        returnPriceAction=" ";
    }
    return returnPriceAction;



  }
  function checkReturning(url){

    var cookieStorage = localStorage.getItem('InvestiocityReturningUser') ;
    if (cookieStorage ){
      

      const newWindow = window.open(url)
      if (newWindow) newWindow.opener = null
    }else {
      setOpen(true);

    }


  }



  function checkPositive(num) {
      
    if (num<0){
      return false
    }else if (num>0) 
    {
      return true
    } 
  }
  const addDefaultSrc= (ev) =>{
    ev.target.src = 'data:image/jpeg;base64,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'
  }
  const CityData=[
    // /{ key: 0, text: 'Select City For Newsletter', value: "" },
    { key: 1, text: 'Houston', value: "Houston" },
    { key: 2, text: 'Austin', value: "Austin" },
    { key: 3, text: 'Miami', value: "Miami" },
    { key: 4, text: 'San Francisco', value: "San Francisco" }
  ]
  async function  handleSubmit(url){
    //e.preventDefault();
    console.log("In log");
    if (!emailValidation())
    {
      return false; 
    }
    if (city==="Preferred NewsLetter City")
    {
      setCityNotValid(true); 
      return false ; 
      

    }else {
      setCityNotValid(false); 
      const token=  await emailSupport({
        emailaddress,city
      });
      localStorage.setItem('InvestiocityReturningUser', true) 
      localStorage.setItem('InvestiocityEmail', emailaddress) 
      setOpen(false);

      const newWindow = window.open(url)
      if (newWindow) newWindow.opener = null

    }
 
  
  

    }


  return ( <Container>
    <Card sx={{ maxWidth: 345 }}>

    
      <StarRatings  rating={props.ourRating} starRatedColor="#f5cb42" numberOfStars={10} name='rating' starDimension='15px'  starSpacing="2px" /><Typography style={{fontSize: "13px"}}> {     props.ourRating} out of 10</Typography>
      <Tooltip  title={<p style={{ fontSize: "15px", color:"White" }}>{props.investmentDecisionReason} </p>}>
                      <p style={{fontSize: "15px"}}>Why is it ranked this way?<IconButton><HelpOutlineIcon />    </IconButton></p>
                      </Tooltip> 
      <CardMedia  onError={addDefaultSrc}
        component="img"
        //height="194"
        image={props.image}
        alt="Image Not Available"
      />
               <CardContent>
      {/* <div style={{fontSize: "13px",color:checkPositive(props.priceIncreasePercentage) ? 'black' : 'black'}}   fontSize="large" >{props.address}</div> */}
      <div style={{fontSize: "13px",color:checkPositive(props.priceIncreasePercentage) ? 'black' : 'black'}}   fontSize="Medium" >LISTED PRICE: {props.price } </div>      
      <div     style={{fontSize: "15px"}}> 
                      Days On Market: {props.timeOnZillow}
                       </div>
      <br></br>
      <div style={{fontSize: "15px",color:checkPositive(props.priceIncreasePercentage) ? 'red' : 'green'}}   fontSize="large" >{buildPercentageString(props.priceIncreasePercentage)}</div>
         <Typography variant="body2" color="text.primary">{props.nearbyHomeAvg + " Nearby Home Avg"}</Typography>
       <hr>
       </hr>
       <br></br>
       <div style={{fontSize: "15px",color:checkPositive(props.similarpriceincreasepercentage) ? 'red' : 'green'}}   fontSize="large" >{buildSimilarPercentageString(props.similarpriceincreasepercentage)}</div>
         <Typography variant="body2" color="text.primary" >{props.similarHomeAvg + " Similar Home Avg"}</Typography>
         <hr>
       </hr>
       <br></br>
        <Typography variant="body2" color="text.secondary">
          {props.shortdesc}
        </Typography>
        <br></br>
         <p  style={{color:"red", align:"center",fontSize: "15px", display: 'inline' }}>{getPriceAction("test")}  </p><p  style={{color:"white", align:"center",fontSize: "15px", display: 'inline' }}>placeholder </p>
         
 
      
      </CardContent>

      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
        <Button  onClick={()=>checkReturning(FE_URL + "/propdetails?zpid=" + props.zpid.trim() + "&loadID=" + props.loadID + "&eid=-1")}> VIEW COMPS, DETAILS AND PHOTOS</Button>


      </CardActions>
         </Card>
        
         <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={maxWidth}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
           // handleClose();
          },
        }}      >
        
        {/* <DialogTitle>Subscribe</DialogTitle> */}
        <DialogContent>
  <DialogContentText>
    <div className="form-container1" style={{ padding: "20px" }}>
      <Typography 
        fontWeight="bold" 
        color="#5D89D1" 
        id="modal-modal-title" 
        variant="h4" 
        component="h2" 
        align="center"
        gutterBottom      >
        NEW AND RETURNING USERS
      </Typography>
      
      <Typography 
        id="modal-modal-title" 
        variant="h6" 
        component="h4" 
        align="center"
        gutterBottom      >
        Sign up for our FREE Daily Newsletter to get FULL access to all our property details, comps, neighborhood info, and MORE!
      </Typography>
      
      <Typography 
        id="modal-modal-title" 
        variant="h6" 
        component="h4" 
        align="center"
        gutterBottom      >
        Our FREE Newsletter delivers top-ranked properties listed in the last 24 hours right to your inbox.
      </Typography>
      
      <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <TextField
            id="filled-email-input"
            label="Email"
            type="email"
            autoComplete="current-password"
            variant="filled"
            onChange={e => setEmailAddress(e.target.value)}
            fullWidth/>
          {emailNotValid && <p style={{ fontWeight: "bold", fontSize: "15px", color: "red" }}>Enter Email</p>}
        </FormControl>
      </div>
      
      <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 300 }}>
          <Select
            labelId="select-city-label"
            id={props.zpid}
            value={city}
            onChange={handleChangeCityData}
            fullWidth>
            <MenuItem value="Preferred NewsLetter City">Preferred NewsLetter City</MenuItem>
            <MenuItem value="Houston">Houston</MenuItem>
            <MenuItem value="Austin">Austin</MenuItem>
            <MenuItem value="Miami">Miami</MenuItem>
            <MenuItem value="San Francisco">San Francisco</MenuItem>
          </Select>
          {cityNotValid && <p style={{ fontWeight: "bold", fontSize: "15px", color: "red" }}>Select A City</p>}
        </FormControl>
      </div>
      
      <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <Button 
          variant="contained" 
          onClick={() => handleSubmit(`${FE_URL}/propdetails?zpid=${props.zpid.trim()}&loadID=${props.loadID}&eid=-1`)} 
          endIcon={<SendIcon />}
          fullWidth
          style={{ maxWidth: "300px" }}        >
          Subscribe
        </Button>
      </div>
      
      <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <img src={NewsLetterImage} alt="Newsletter" style={{ height: "400px", width: "100%", maxWidth: "700px" }} />
      </div>
    </div>
  </DialogContentText>
  
  <Typography id="modal-modal-description" sx={{ mt: 2 }} align="center">
    ** We will never share or sell your email address for any reason
  </Typography>
</DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={()=>handleSubmit(FE_URL + "/propdetails?zpid=" + props.zpid.trim() + "&loadID=" + props.loadID + "&eid=-1")} >Subscribe</Button>
        </DialogActions> */}
       
      </Dialog>
     
             </Container>
  );
}